<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="speaker_name"
        class="form-control-label">Name</label>
        <input
          required
          id="speaker_name"
          v-model="item.name"
          :class="['form-control', !isValid('name') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="speaker_image"
        class="form-control-label">Image</label>
        <image-uploader id="speaker_image" class="ml-2" :parentImgDataUrl="itemImage" @imageUrlChanged="imageUrlChanged" v-model="item.image"></image-uploader>
        <!-- <select
          v-model="item.image"
          id="speaker_image"
          class="form-control"
        >
          <option v-for="selectItem in imageSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"
                  
                  :selected="isSelected('image', selectItem['@id'])">
          {{ selectItem['contentUrl'] }}</option>
        </select> -->
      <div
        v-if="!isValid('image')"
        class="invalid-feedback">{{ violations.image }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
  import ImageUploader from '../image-uploader/ImageUploader';
  import { find, get, isUndefined } from 'lodash';
  import { mapFields } from 'vuex-map-fields';
  import { mapActions } from 'vuex';
  import apiUrl from '../../store/modules/links/links';

export default { 
  data() {
    return {      
      itemImage: '',      
    }
  },   
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => {},
    },

    initialValues: {
      type: Object,
      default: () => {},
    },  
  },

  created() {
    // console.log(this.item);
    this.imageGetSelectItems();
    if (this.item.image != null) {
      this.itemImage = this.item.image['@id'];
    } else {
      this.itemImage = ''      
    }   
  },
  mounted() {    
    this.getCurrentImagePath();        
  },
  components: {
		'image-uploader': ImageUploader,		
	},
  computed: {
    ...mapFields('mediaobject/list', {
      'imageSelectItems': 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
        imageGetSelectItems: 'mediaobject/list/getSelectItems',
    }),

    isSelected(collection, id) {
      return find(this.item[collection], ['@id', id]) !== undefined;
    },

    isValid(key) {
      return isUndefined(get(this.violations, key));
    },

    imageUrlChanged(e) {
      console.log(e);      
      this.itemImage = apiUrl.API_HOST + '/media/' + e.filePath;
      // this.itemImageId = e['@id'];
      this.item.image = e['@id'];
      // console.log(this.itemImageId);
    },

    getCurrentImagePath() {      
      this.imageSelectItems.forEach(imageObject => {       
        if (imageObject['@id'] == this.itemImage) {
          this.itemImage = apiUrl.API_HOST + '/media/' + imageObject['filePath'];          
        }        
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/speaker/Form.vue